interface Currency {
  value: string;
  display: string;
  minorUnit: number;
}

const currencies: Record<string, Currency> = {
  HKD: {
    value: 'HKD',
    display: 'HKD',
    minorUnit: 2,
  },
  USD: {
    value: 'USD',
    display: 'USD',
    minorUnit: 2,
  },
};

/**
 * Returns the number of decimal places (minor unit) for a currency.
 * Clamped between 0 and 4 for floating point precision safety.
 * @param currency - ISO 4217 currency code
 * @returns Number of decimal places (0-4), defaults to 2 for unknown currencies
 */
export function getMinorUnit(currency: string): number {
  if (currency === 'JPY') {
    return 0;
  }

  const minorUnit = currencies[currency]?.minorUnit ?? 2;
  return Math.max(0, Math.min(4, minorUnit));
}

export const currenciesKeys = ['HKD', 'USD'];
export const currencyDefault = currencies.HKD;

// Translation mapping object
const currencyTranslations: Record<string, Record<string, string>> = {
  HKD: { en: 'HKD', zh: '港元' },
  USD: { en: 'USD', zh: '美元' },
};

// Function to translate currency labels
export function translateCurrency(currencyKey: string, language: string): string {
  const translations = currencyTranslations[currencyKey];
  if (!translations) {
    return currencyKey;
  }
  return translations[language] || currencyKey;
}

export default currencies;
